import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useGameStore } from './store/gameStore';
import { authAPI, cardAPI, battleAPI } from './services/api';
import LoginPage from './pages/LoginPage';
import MainMenu from './pages/MainMenu';
import GameHub from './pages/GameHub';
import BattleArena from './pages/BattleArena';
import CardLibrary from './pages/CardLibrary';
import TeamBuilder from './pages/TeamBuilder';
import './App.css';
function App() {
    const { isLoggedIn, currentPage, setUser, setCards, setUserCards, setTeams, setAnnouncements } = useGameStore();
    // Initialize game data on login
    useEffect(() => {
        if (isLoggedIn) {
            initializeGameData();
        }
    }, [isLoggedIn]);
    const initializeGameData = async () => {
        try {
            const [userRes, cardsRes, userCardsRes, teamsRes, announcementsRes] = await Promise.all([
                authAPI.getProfile(),
                cardAPI.getAllCards(),
                cardAPI.getUserCards(),
                cardAPI.getTeams(),
                battleAPI.getDailyDraws() // Placeholder
            ]);
            setUser(userRes.data.user);
            setCards(cardsRes.data);
            setUserCards(userCardsRes.data);
            setTeams(teamsRes.data);
        }
        catch (error) {
            console.error('Failed to initialize game data:', error);
        }
    };
    const renderPage = () => {
        if (!isLoggedIn)
            return _jsx(LoginPage, {});
        switch (currentPage) {
            case 'home':
                return _jsx(MainMenu, {});
            case 'game-hub':
                return _jsx(GameHub, {});
            case 'battle':
                return _jsx(BattleArena, {});
            case 'card-library':
                return _jsx(CardLibrary, {});
            case 'team-builder':
                return _jsx(TeamBuilder, {});
            default:
                return _jsx(MainMenu, {});
        }
    };
    return (_jsx("div", { className: "app", children: renderPage() }));
}
export default App;
